angular.module('impactx.smartform').controller('SFTUsageTypeCtrl', ['$scope', '$mdDialog', 'TranslationService', SFTUsageTypeCtrl]);

function SFTUsageTypeCtrl($scope, $mdDialog, TranslationService)
{
    var self = this;

    $scope.usageType = JSON.parse(JSON.stringify(self.usageType));
    $scope.abortLabel = TranslationService.get("abort");
    $scope.acceptLabel = TranslationService.get("accept");

    $scope.cancel = function() {
        $mdDialog.cancel();
    };

    $scope.accept = function() {
        $mdDialog.hide($scope.usageType.selected);
    };
}